import { Outlet } from 'react-router-dom';

import type { FeatureConfig } from '@platform/client/features';

import { hasRequiredCapability } from '@apis/capability/has-required-capability/has-required-capability';
import { DetectionServiceApiProvider } from '@apis/detection-service/detection-service-api-provider';
import { SystemCapabilityGuard } from '@packages/components/capabilities/system-capability-guard/system-capability-guard';

import i18n from './locales/i18n';

export default {
  routes: [
    {
      path: 'detection-catalog',
      element: (
        <SystemCapabilityGuard capabilityId="detection_catalog">
          <DetectionServiceApiProvider>
            <Outlet />
          </DetectionServiceApiProvider>
        </SystemCapabilityGuard>
      ),
      children: [
        {
          index: true,
          lazy: () => import('./detection-list/detection-list.page'),
        },
        {
          path: ':detectionId',
          lazy: () => import('./detection-details/detection-details.page'),
        },
      ],
    },
  ],
  navigation: ({ systemCapabilities }) => {
    const hasDetectionCatalogAccess = hasRequiredCapability(
      'detection_catalog',
      systemCapabilities,
    );

    if (!hasDetectionCatalogAccess) {
      return {};
    }

    return {
      managedDetectionResponse: {
        detectionCatalog: {
          title: i18n.t('detection-catalog:detectionCatalog'),
          segment: '/detection-catalog',
        },
      },
    };
  },
} satisfies FeatureConfig;
